import { Progress } from 'antd'
import React from 'react'
import { homeCards } from '../../Utils/constants'

const Card = () => {
    return (
        homeCards.map(card => <div className={`oee-homepage-card oee-homepage-card-type-${card.type}`}>
            <div className={`oee-homepage-card-head oee-homepage-card-head-type-${card.type}`}>{card.name}</div>
            <div className={`oee-homepage-card-progress oee-homepage-card-progress-type-${card.type}`}>
                <Progress type="circle"
                    percent={card.percent}
                    format={(percent) => <span className='oee-homepage-card-progress-text'>
                        <span className='oee-homepage-card-progress-text-percent'>{`${percent}%`}</span>
                        <span className='oee-homepage-card-progress-text-plant'>{card.plant}</span>
                    </span>}
                    width={100}
                    strokeWidth={5}
                    strokeColor={card.type === 1 ? "#1E6EFE" : card.type === 2 ? "#ED9226" : "#EB5757"} />
            </div>
        </div>)
    )
}

export default Card